import { createStore, setStateHelper } from "@neonumy/neonumy-ui";
import { StoreApi, UseBoundStore } from "zustand";

interface StoreState {
  userData: GetUserByToken;
  setUserData: (updater: ((oldState: GetUserByToken) => GetUserByToken) | GetUserByToken) => void;
  companySelected: CompanySelected;
  setCompanySelected: (companySelected?: CompanySelected | undefined) => void;
  accountingFirmSelected: AccountingFirmSelected;
  setAccountingFirmSelected: (accountingFirmSelected?: AccountingFirmSelected | undefined) => void;
  isCompanySelectOpen: boolean;
  setIsCompanySelectOpen: (isCompanySelectOpen: boolean) => void;
  companySoftware: SoftwareType;
  setCompanySoftware: (companySoftware: SoftwareType) => void;
  createUpdateUserLoading: boolean;
  setCreateUpdateUserLoading: (createUpdateUserLoading: boolean) => void;
  saveButtonWasClicked: boolean;
  setSaveButtonWasClicked: (saveButtonWasClicked: boolean) => void;
  dataChanged: boolean;
  setDataChanged: (dataChanged: boolean) => void;
  resetStore: () => void;
}

const initialState = {
  userData: undefined,
  companySelected: undefined,
  accountingFirmSelected: undefined,
  isCompanySelectOpen: false,
  companySoftware: undefined,
  createUpdateUserLoading: undefined,
  saveButtonWasClicked: false,
  dataChanged: false,
};

const useStore: UseBoundStore<StoreApi<StoreState>> = createStore<StoreState>(
  (set: (fn: (draft: StoreState) => void) => void) => ({
    ...initialState,
    resetStore: () => {
      set(() => ({
        ...initialState,
      }));
    },
    setUserData: (updater: ((oldState: GetUserByToken) => GetUserByToken) | GetUserByToken) => {
      set(state => {
        return {
          ...state,
          userData: typeof updater === "function" ? updater(state.userData || {}) : updater,
        };
      });
    },
    setCompanySoftware: (companySoftware: SoftwareType) => {
      setStateHelper("companySoftware", companySoftware, set);
    },
    setCompanySelected: (companySelected: CompanySelected) => {
      setStateHelper("companySelected", companySelected, set);
    },
    setAccountingFirmSelected: (accountingFirmSelected: AccountingFirmSelected) => {
      setStateHelper("accountingFirmSelected", accountingFirmSelected, set);
    },
    setIsCompanySelectOpen: (isCompanySelectOpen: boolean) => {
      setStateHelper("isCompanySelectOpen", isCompanySelectOpen, set);
    },
    setCreateUpdateUserLoading: (createUpdateUserLoading: boolean) => {
      setStateHelper("createUpdateUserLoading", createUpdateUserLoading, set);
    },
    setSaveButtonWasClicked: (saveButtonWasClicked: boolean) => {
      setStateHelper("saveButtonWasClicked", saveButtonWasClicked, set);
    },
    setDataChanged: (dataChanged: boolean) => {
      setStateHelper("dataChanged", dataChanged, set);
    },
  }),
);

export default useStore;
